/* unplugin-vue-components disabled */import script from "./UserInfoBox.vue?vue&type=script&setup=true&lang=js"
export * from "./UserInfoBox.vue?vue&type=script&setup=true&lang=js"

import "./UserInfoBox.vue?vue&type=style&index=0&id=43a8f0c3&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43a8f0c3"]])

export default __exports__